import React from "react";
import "./index.less";

class CertificateDetail extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
        };
    }

    componentDidMount() {
        document.getElementsByTagName("body")[0].style.cssText =
            "height:100%;background: #F4F4F5 !important";
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }

            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    console.log(this.state.urlOps);
                }
            );
        }
    }

    render() {
        var { urlOps } = this.state;
        return (
            <div className="certificateDetailBox">
                {urlOps.id === "1" ? (
                    <img src="https://static.hellogil.com/oss-prod-unsafe-group/statics/bd23c639c3db4e43869dc1a96debd6a5.png" />
                ) : (
                    ""
                )}
            </div>
        );
    }
}
export default CertificateDetail;



// WEBPACK FOOTER //
// ./src/staticPage/certificate/detail/index.js